// Global interval store (shared for all blocks)
window.__viewerIntervals = window.__viewerIntervals || {};

function renderIconicProductViewerCounter(component) {
  if (!component) return;
  
  // Check if already rendered to avoid duplicate renders
  if (component.dataset.rendered === "true") {
    return;
  }
  
  const settings = JSON.parse(component.dataset.settings);
  const blockId = component.dataset.blockId;
  
  // Main container
  const container = document.createElement("div");
  container.id = `iconic-product-viewer-counter-${blockId}`;
  container.className = "iconic-product-view-counter-container";
  
  // Apply responsive margin
  function applyMargin() {
    const isMobile = window.innerWidth < 768;
    const margin = isMobile
      ? Math.round(settings.margin_top_bottom * 0.75)
      : settings.margin_top_bottom;
    
    container.style.marginTop = margin + "px";
    container.style.marginBottom = margin + "px";
  }
  applyMargin();
  window.addEventListener("resize", applyMargin);
  
  // Counter wrapper
  const wrapper = document.createElement("div");
  wrapper.className = "iconic-view-counter-wrapper iconic-d-flex iconic-gap-1 iconic-px-2 iconic-align-items-center";
  wrapper.style.backgroundColor = settings.background_color;
  wrapper.style.color = settings.text_color;
  wrapper.style.borderRadius = settings.box_radius + "px";
  
  // Apply border style
  if (settings.highlight_border) {
    wrapper.style.borderLeft = `${settings.box_border}px solid ${settings.border_color}`;
  } else {
    wrapper.style.border = `${settings.box_border}px solid ${settings.border_color}`;
  }
  
  // Apply responsive padding and font sizes
  function applyResponsiveStyles() {
    const isMobile = window.innerWidth < 768;
    const padding = isMobile
      ? Math.round(settings.padding_top_bottom * 0.75)
      : settings.padding_top_bottom;
    const textSize = isMobile
      ? Math.round(settings.text_size * 0.75)
      : settings.text_size;
    const iconSize = isMobile
      ? Math.round(settings.icon_font_size * 0.75)
      : settings.icon_font_size;
    
    wrapper.style.paddingTop = padding + "px";
    wrapper.style.paddingBottom = padding + "px";
    wrapper.style.fontSize = textSize + "px";
    wrapper.style.lineHeight = (textSize + 5) + "px";
    
    iconSpan.style.fontSize = iconSize + "px";
    iconSpan.style.lineHeight = (iconSize + 5) + "px";
  }
  
  // Icon
  const iconSpan = document.createElement("span");
  iconSpan.className = "iconic-view-count-icon";
  iconSpan.textContent = settings.counter_icon || "🔥";
  
  // Number
  const numberSpan = document.createElement("span");
  numberSpan.className = "iconic-view-count-number";
  numberSpan.style.fontWeight = "600";
  numberSpan.style.color = settings.number_color;
  
  // Text
  const textSpan = document.createElement("span");
  textSpan.className = "iconic-view-count-text";
  textSpan.textContent = settings.counter_text || "People are viewing this product right now.";
  
  // Assemble elements
  wrapper.appendChild(iconSpan);
  wrapper.appendChild(numberSpan);
  wrapper.appendChild(textSpan);
  container.appendChild(wrapper);
  component.appendChild(container);
  
  // Apply responsive styles
  applyResponsiveStyles();
  window.addEventListener("resize", applyResponsiveStyles);
  
  // Mark as rendered
  component.dataset.rendered = "true";
  
  // Initialize counter
  initViewerCounter(blockId, settings, numberSpan);
}

function initViewerCounter(blockId, settings, numberElement) {
  if (!numberElement) return;
  
  const config = {
    min: settings.min_views || 15,
    max: settings.max_views || 40,
    interval: (settings.update_speed || 3) * 1000,
    range: settings.update_range || 5,
    cookieName: `iconic-viewer-count-${blockId}`
  };
  
  // Get or initialize count
  let count = parseInt(getCookie(config.cookieName));
  if (isNaN(count) || count < config.min || count > config.max) {
    count = Math.floor(Math.random() * (config.max - config.min + 1)) + config.min;
  }
  
  // Display initial count
  numberElement.textContent = count;
  setCookie(config.cookieName, count, 1);
  
  // Update function
  const updateCount = () => {
    const min = Math.max(config.min, count - config.range);
    const max = Math.min(config.max, count + config.range);
    
    let nextCount = Math.floor(Math.random() * (max - min + 1)) + min;
    
    // Ensure count changes
    if (nextCount === count) {
      nextCount += nextCount === config.max ? -1 : 1;
    }
    
    count = nextCount;
    numberElement.textContent = count;
    setCookie(config.cookieName, count, 1);
  };
  
  // Clear old interval if exists
  if (window.__viewerIntervals[blockId]) {
    clearInterval(window.__viewerIntervals[blockId]);
  }
  
  // Start new interval
  window.__viewerIntervals[blockId] = setInterval(updateCount, config.interval);
}

function stopViewerCounter(blockId) {
  if (window.__viewerIntervals[blockId]) {
    clearInterval(window.__viewerIntervals[blockId]);
    delete window.__viewerIntervals[blockId];
  }
}

// Cookie helpers
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 86400000);
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;
}

function getCookie(name) {
  const prefix = name + "=";
  return document.cookie
    .split(";")
    .map(c => c.trim())
    .find(c => c.startsWith(prefix))
    ?.substring(prefix.length) || null;
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".iconic-product-viewer-counter-js").forEach(renderIconicProductViewerCounter);
});

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener("shopify:section:load", (e) => {
    const section = e.target;
    const blocks = section.querySelectorAll(".iconic-product-viewer-counter-js");
    blocks.forEach(block => {
      block.innerHTML = "";
      block.dataset.rendered = "false";
      renderIconicProductViewerCounter(block);
    });
  });
  
  document.addEventListener("shopify:section:unload", (e) => {
    const section = e.target;
    const blocks = section.querySelectorAll(".iconic-product-viewer-counter-js");
    blocks.forEach(block => {
      const blockId = block.dataset.blockId;
      stopViewerCounter(blockId);
    });
  });
  
  document.addEventListener("shopify:block:select", (e) => {
    const blockId = e.detail.blockId;
    const block = document.querySelector(`[data-block-id="${blockId}"]`);
    if (block && block.classList.contains("iconic-product-viewer-counter-js")) {
      setTimeout(() => {
        block.innerHTML = "";
        block.dataset.rendered = "false";
        renderIconicProductViewerCounter(block);
      }, 200);
    }
  });
  
  document.addEventListener("shopify:block:deselect", (e) => {
    const blockId = e.detail.blockId;
    stopViewerCounter(blockId);
  });
}

// Cleanup intervals on page unload
window.addEventListener("beforeunload", () => {
  Object.keys(window.__viewerIntervals).forEach(blockId => {
    stopViewerCounter(blockId);
  });
});